import { POST } from "../../index";


export const getCloudFence = (param) => POST("/v1/cloudFence/getCloudFence", param);
export const getFenceCar = (param) => POST("/v1/cloudFence/getFenceCar", param);
export const addCloudFence = (param) => POST("/v1/cloudFence/addCloudFence", param);
export const updateCloudFence = (param) => POST("/v1/cloudFence/updateCloudFence", param);
export const deleteCloudFence = (param) => POST("/v1/cloudFence/deleteCloudFence", param);
export const getChoiceCar = (param) => POST("/v1/cloudFence/getChoiceCar", param);
